// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, initializeAuth, inMemoryPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDbSyxi-jz_vSj90bm-2LCzDt0uuMFS_Io",
  authDomain: "ting-vision.firebaseapp.com",
  projectId: "ting-vision",
  storageBucket: "ting-vision.firebasestorage.app",
  messagingSenderId: "186628423921",
  appId: "1:186628423921:web:2ae2a0d4c8afd34579e950",
  measurementId: "G-Y4J506RS0Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// The embedded game uses the native account handoff only. getAuth also starts
// a popup/redirect iframe proactively on mobile, which an in-app WebView does
// not need. Configure memory-only auth before that iframe can be created.
export const auth = process.env.REACT_APP_APP_VARIANT === 'citizen-science'
  ? initializeAuth(app, { persistence: inMemoryPersistence })
  : getAuth(app);
export const functions = getFunctions(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app


